/* PawsOn 2026 — box builder size switcher.
 *
 * Standard ARIA tabs: click or arrow keys select a size, and the matching
 * panel shows. Every panel is in the HTML from the start, so the boxes are
 * crawlable and the first paint needs no JS.
 *
 * Choosing a size changes content that on a narrow screen is usually below
 * the fold, so the tap looks like it did nothing. When the new panel is not
 * meaningfully visible the page scrolls to it. The test is what is on screen
 * rather than a breakpoint, so it does nothing on a desktop where the panel
 * was in view all along.
 */
(function () {
  'use strict';

  function initTabs(tablist) {
    if (tablist.dataset.pwTabsReady) return;
    tablist.dataset.pwTabsReady = 'true';

    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    function panelFor(tab) {
      var id = tab.getAttribute('aria-controls');
      return id ? document.getElementById(id) : null;
    }

    function select(tab, moveFocus) {
      tabs.forEach(function (candidate) {
        var isTarget = candidate === tab;
        var panel = panelFor(candidate);

        candidate.setAttribute('aria-selected', isTarget ? 'true' : 'false');
        candidate.tabIndex = isTarget ? 0 : -1;
        if (panel) panel.hidden = !isTarget;
      });

      if (moveFocus) tab.focus();
    }

    function revealPanel(tab) {
      var panel = panelFor(tab);
      if (!panel || panel.hidden) return;

      /* Only where the tabs stack. Below 750px the three size cards sit one
         under another and push the panel most of a screen down, so a tap
         changes something the reader cannot see. Above it the tabs are a
         single row and the panel is already there. 749px is the breakpoint
         the stylesheet stacks at; the two need to move together. */
      if (!window.matchMedia('(max-width: 749px)').matches) return;

      /* Already at the top: nothing to do. */
      if (panel.getBoundingClientRect().top < 140) return;

      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      panel.scrollIntoView({ block: 'start', behavior: reduced ? 'auto' : 'smooth' });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        select(tab, false);
        revealPanel(tab);
      });
    });

    tablist.addEventListener('keydown', function (event) {
      var current = tabs.indexOf(document.activeElement);
      if (current === -1) return;

      var next = null;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tabs.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;

      if (next === null) return;
      event.preventDefault();
      select(tabs[next], true);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-pw-tabs]').forEach(initTabs);
  }

  if (document.readyState !== 'loading') {
    init(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
